import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable, of, throwError} from 'rxjs';
import {UserBindVip, UserBindVipBinding} from '../../models/vip/user-bind-vip.model';
import {delay} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConquerVipService {

  private readonly baseUrl = `${environment.backend.url}/api/user/v1/vip`;

  constructor(private readonly http: HttpClient) { }

  public getVipInfo(queryBindings: boolean): Observable<UserBindVip> {
    return this.http.get<UserBindVip>(`${this.baseUrl}/bindings?queryBindings=${queryBindings ? 'true' : 'false'}`);
  }

  /**
   * Bind a VIP account to a user
   * Note: This is a mock implementation until the actual endpoint is available
   */
  public bindVipAccount(recaptchaToken: string, userName: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/bind/${userName}`, {}, {
      headers: {
        'x-recaptcha-token': recaptchaToken,
      }
    });
  }

  /**
   * Unbind a VIP account from a user
   * Note: This is a mock implementation until the actual endpoint is available
   */
  public unbindVipAccount(recaptchaToken: string, accountId: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/binding/${accountId}`, {
      headers: {
        'x-recaptcha-token': recaptchaToken,
      }
    });
  }
}
